var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "q-form",
            { ref: "editForm" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "보호구 신청 상세" },
                },
                [
                  _c(
                    "template",
                    { slot: "card-button" },
                    [
                      _c(
                        "q-btn-group",
                        { attrs: { outline: "" } },
                        [
                          _vm.editable
                            ? _c("c-btn", {
                                attrs: {
                                  url: _vm.saveUrl,
                                  isSubmit: _vm.isSave,
                                  param: _vm.data,
                                  mappingType: _vm.saveType,
                                  label: "LBLSAVE",
                                  icon: "save",
                                },
                                on: {
                                  beforeAction: _vm.saveData,
                                  btnCallback: _vm.saveCallback,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            required: true,
                            label: "신청일",
                            editable: _vm.editable,
                            name: "requestDate",
                          },
                          model: {
                            value: _vm.data.requestDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestDate", $$v)
                            },
                            expression: "data.requestDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-plant", {
                          attrs: {
                            type: "edit",
                            required: true,
                            label: "LBLPLANT",
                            editable: _vm.editable,
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.data.plantCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "plantCd", $$v)
                            },
                            expression: "data.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-dept", {
                          attrs: {
                            required: true,
                            label: "신청부서",
                            editable: _vm.editable,
                            name: "requestDeptCd",
                          },
                          model: {
                            value: _vm.data.requestDeptCd,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestDeptCd", $$v)
                            },
                            expression: "data.requestDeptCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-3" },
                      [
                        _c("c-field", {
                          attrs: {
                            required: true,
                            label: "신청자",
                            editable: _vm.editable,
                            name: "requestUserId",
                          },
                          model: {
                            value: _vm.data.requestUserId,
                            callback: function ($$v) {
                              _vm.$set(_vm.data, "requestUserId", $$v)
                            },
                            expression: "data.requestUserId",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "table",
              attrs: {
                title: "보호구 신청 목록",
                tableId: "table",
                columns: _vm.grid.columns,
                data: _vm.data.detailList,
                merge: _vm.grid.merge,
                isFullScreen: false,
                columnSetting: false,
                filtering: false,
                usePaging: false,
                isExcelDown: false,
                editable: _vm.editable,
                gridHeight: "600px",
                selection: "multiple",
                rowKey: "requestListId",
              },
            },
            [
              _c("template", { slot: "table-button" }, [
                _c(
                  "div",
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: { label: "LBLADD", icon: "add" },
                              on: { btnClicked: _vm.addGear },
                            })
                          : _vm._e(),
                        _vm.editable
                          ? _c("c-btn", {
                              attrs: { label: "LBLEXCEPT", icon: "remove" },
                              on: { btnClicked: _vm.removeGear },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }